var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
var PageFoot = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: rgba(0, 0, 0, 0.85);\n  padding: 16px;\n  background-color: #fff;\n"])));
export { PageFoot };